import { push } from 'connected-react-router';
import { put } from 'redux-saga/effects';

import ROUTES from 'app/routes/paths';
import { string } from 'utils/formatters';

function* registrationRedirect() {
  yield put(push(string.withDefaultPagination(ROUTES.process.definition._())));
}

export default registrationRedirect;
